// Privacy Cookie Page
export function CookiePage() {
  return `
    <section class="section bg-gray-50 min-h-screen py-12">
      <div class="container max-w-3xl mx-auto bg-white rounded-lg shadow-md p-8">

        <h1 class="text-2xl font-bold mb-6 text-gray-900">Cookie Policy</h1>

        <p class="mb-4 text-gray-700">
          At CeeCasasEspana.com we use cookies and similar technologies to ensure the proper functioning of the website, improve the user experience, and anonymously analyze site usage. We process data in accordance with the General Data Protection Regulation (GDPR/AVG).
        </p>

        <h2 class="text-xl font-semibold mt-6 mb-2 text-gray-800">What are cookies?</h2>
        <p class="mb-4 text-gray-700">
          Cookies are small text files that are stored on your device when you visit a website. They allow the site to remember information about your visit, such as your preferences, and help improve navigation and site performance.
        </p>

        <h2 class="text-xl font-semibold mt-6 mb-2 text-gray-800">What types of cookies do we use?</h2>
        <ul class="list-disc pl-6 mb-4 text-gray-700">
          <li>
            <strong>Technical and functional cookies:</strong>
            These are necessary for the basic functioning of the website, such as navigation, security, and the use of contact and booking forms.
          </li>
          <li>
            <strong>Analytics cookies:</strong>
            We use Google Analytics solely for statistical purposes and to improve the website. The IP address is anonymized before storage and the data collected is not used for advertising or profiling purposes.
          </li>
          <li>
            <strong>We do not use advertising cookies or tracking cookies for commercial purposes.</strong>
          </li>
        </ul>

        <h2 class="text-xl font-semibold mt-6 mb-2 text-gray-800">Consent management</h2>
        <p class="mb-4 text-gray-700">
          When you first access our website, you will see a cookie notice where you can accept or reject analytics cookies. Technical cookies are only used when necessary for the operation of the site.
        </p>
        <p class="mb-4 text-gray-700">
          You can modify or withdraw your consent at any time using the cookie settings icon available on the website.
        </p>

        <h2 class="text-xl font-semibold mt-6 mb-2 text-gray-800">Withdrawal of consent</h2>
        <p class="mb-4 text-gray-700">
          You can withdraw or modify your consent at any time, without affecting the lawfulness of processing carried out previously, using the cookie settings available on the site.
        </p>

        <h2 class="text-xl font-semibold mt-6 mb-2 text-gray-800">Your rights</h2>
        <p class="mb-4 text-gray-700">
          In accordance with the GDPR/AVG, you have the right to access, rectify, and delete your personal data, as well as other rights detailed in our
          <a href="/privacy/" class="text-blue-600 hover:underline">Privacy Policy</a>.
        </p>

        <h2 class="text-xl font-semibold mt-6 mb-2 text-gray-800">Contact</h2>
        <p class="mb-4 text-gray-700">
          If you have questions about our cookie policy, you can contact us via our
          <a href="/contact/" class="text-blue-600 hover:underline">contact form</a>.
        </p>

        <p class="text-xs text-gray-400 mt-8">
          Last updated: 17-12-2025
        </p>

      </div>
    </section>
  `;
}
